import React, { useEffect, useState, Suspense } from "react";
import styles from "../../../styles/enquiry-form-2.module.css";
import ReactSelect from "../../../components/ReactSelect";
import { isNonEmpty, isValidEmail, isValidMobile, } from "../../../utils/common-utils";
import { saveSchoolEnquiry, SendOTPForSchoolEnquiry, VerifyForSchoolEnquiry } from "../../../apis/auth";
import { showToast } from "../../../components/CustomToast";
import { trackSchoolEnquiryConversion } from "../../../utils/RouteConstants";

const MdOutlineClose = React.lazy(() => import('react-icons/md').then(module => ({ default: module.MdOutlineClose })));

const OtpText = `OTP will be sent to your mobile number for verification`;
const designationOptions = [
    { value: "School Leadership", label: "School Leadership" },
    { value: "Principal", label: "Principal" },
    { value: "Vice Principal", label: "Vice Principal" },
    { value: "Administrator", label: "Administrator" },
    { value: "Teacher", label: "Teacher" },
    { value: "Student", label: "Student" },
    { value: "Other", label: "Other" }
];

const boardOptions = [
    { value: "CBSE", label: "CBSE" },
    { value: "ICSE", label: "ICSE" },
    { value: "Other", label: "Other" }
];
export default function EnquiryFormSchoolAi({ onClose, handleUpdateStep }) {
    const [formData, setFormData] = useState({ form_type: "AiAsstleads" });
    const [otp, setOtp] = useState("");
    const [seconds, setSeconds] = useState(180);
    const [authData, setAuthData] = useState({});
    const [step, setStep] = useState(0);
    const [isTrigger, setIsTrigger] = useState(false);
    const [showOtherDesignation, setShowOtherDesignation] = useState(false);
    const [showOtherBoard, setShowOtherBoard] = useState(false);

    useEffect(() => {
        setSeconds(0);
        setStep(0);
        setIsTrigger(false);
    }, []);

    useEffect(() => {
        let interval = null;
        if (seconds > 0) {
            interval = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [seconds]);


    const handleChange = (key, value) => {
        if (key === "phoneNumber" || key === "principalNumber") {
            value = value?.replace(/[^0-9]/g, '');
            value = value?.slice(0, 10);
        }

        if (key === "designation" && value === "Other") {
            setShowOtherDesignation(true);
            setFormData((prev) => ({ ...prev, [key]: value, otherDesignation: "" }));
        } else if (key === "designation") {
            setShowOtherDesignation(false);
            setFormData((prev) => ({ ...prev, [key]: value, otherDesignation: null }));
        } else if (key === "board" && value === "Other") {
            setShowOtherBoard(true);
            setFormData((prev) => ({ ...prev, [key]: value, otherBoard: "" }));
        } else if (key === "board") {
            setShowOtherBoard(false);
            setFormData((prev) => ({ ...prev, [key]: value, otherBoard: null }));
        } else {
            setFormData((prev) => ({ ...prev, [key]: value }));
        }
    };

    const handleDesignationChange = (selectedOption) => {
        const value = selectedOption ? selectedOption.value : "";
        handleChange("designation", value);
    };

    const handleBoardChange = (selectedOption) => {
        const value = selectedOption ? selectedOption.value : "";
        handleChange("board", value);
    }

    const handleSendOTP = async () => {
        if (formData?.designation === "Other" && !isNonEmpty(formData?.otherDesignation)) {
            showToast("Please specify your designation", "error");
            return;
        }

        setIsTrigger(true);
        const { success, data } = await SendOTPForSchoolEnquiry(
            formData?.phoneNumber,
        );
        setIsTrigger(false);
        if (success) {
            setSeconds(180);
            setAuthData(data?.data);
            setStep(1);
            showToast("OTP sent successfully!", "success");
        } else {
            showToast(data?.message || "Failed to send OTP", "error");
        }
    };

    const handleVerifyOTP = async () => {
        setIsTrigger(true);
        const { success, message } = await VerifyForSchoolEnquiry(authData, otp);
        if (success) {
            let body = { ...formData };
            try {
                const utmSource = localStorage.getItem("utm_source");
                if (utmSource && utmSource.trim() !== "") {
                    body["utmSource"] = utmSource;
                } else {
                    const externalRef = localStorage.getItem("externalRef");
                    body["utmSource"] = externalRef;
                }
            } catch (e) {
            }

            saveSchoolEnquiry(body);
            trackSchoolEnquiryConversion(body);

            setIsTrigger(false);

            handleUpdateStep(1);
        } else {
            setIsTrigger(false);
            showToast(message || "Invalid OTP", "error");
        }
    };

    const resend = () => (
        <div style={{ marginTop: "8px" }}>
            <div className={styles.resendTextContainer}>
                {seconds > 0 && (
                    <div>
                        <b style={{ color: "var(--Neutral-100, #F1F1F1)", textDecoration: "underline" }}>
                            {seconds > 0 && `Resend `}
                        </b>
                        <span style={{ color: "var(--Neutral-100, #F1F1F1)", marginRight: "4px" }}>
                            {seconds > 0 && formatTime(seconds)}
                        </span>
                    </div>
                )}

                {seconds === 0 && (
                    <div
                        style={{ color: "var(--Neutral-100, #F1F1F1)", cursor: "pointer" }}
                        onClick={() => handleSendOTP()}
                    >
                        Resend
                    </div>
                )}
            </div>
        </div>
    );

    const formatTime = (timeInSeconds) => {
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };

    const handleBtnClick = () => {
        if (step == 0) {
            handleSendOTP();
        } else if (isNonEmpty(otp)) {
            handleVerifyOTP();
        }
    }
    const handleOTPChange = (_, input) => {
        input = input?.replace(/[^0-9]/g, '');
        input = input?.slice(0, 4);
        setOtp(input)
    }

    let canSubmit =
        isNonEmpty(formData?.name) &&
        isValidMobile(formData?.phoneNumber) &&
        isNonEmpty(formData?.city) &&
        isNonEmpty(formData?.schoolName) &&
        isNonEmpty(formData?.designation) &&
        isNonEmpty(formData?.board);

    if (
        formData?.designation === "Other" &&
        !isNonEmpty(formData?.otherDesignation?.trim())
    ) {
        canSubmit = false;
    }

    if (
        formData?.board === "Other" &&
        !isNonEmpty(formData?.otherBoard?.trim())
    ) {
        canSubmit = false;
    }

    const showAdditionalSections =
        isNonEmpty(formData?.designation) &&
        !["School Leadership", "Principal"].includes(formData?.designation);

    if (showAdditionalSections) {
        if (
            !isNonEmpty(formData?.["principalName"]) ||
            !isValidMobile(formData?.["principalNumber"])
        ) {
            canSubmit = false;
        }
    }

    let isDisabled = true;
    if (step === 0) {
        isDisabled = canSubmit ? false : true;
    } else if (step == 1) {
        isDisabled = isNonEmpty(otp) ? false : true;
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.titledesk}>Help us bring SchoolAi to your school</div>
                <div className={styles.titlemobile}>Bring SchoolAi to your school</div>
                <div className={styles.close} onClick={onClose}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <MdOutlineClose color="#F1F1F1" size={24} />
                    </Suspense>
                </div>
            </div>
            <div className={styles.subHeader}>Your Details:</div>
            {/* formSection */}
            <div className={styles.formSection}>
                <CustomInput
                    title={"Name"}
                    placeholder={"Full Name"}
                    keyProp={"name"}
                    data={formData}
                    onChange={handleChange}
                    isShow={true}
                />
                <CustomInput
                    title={"Mobile Number"}
                    placeholder={"+91 12345 67890"}
                    keyProp={"phoneNumber"}
                    data={formData}
                    onChange={handleChange}
                    isShow={true}
                />
                <CustomInput
                    title={"School Name"}
                    placeholder={"School Name"}
                    keyProp={"schoolName"}
                    data={formData}
                    onChange={handleChange}
                    isShow={true}
                />
                <ReactSelect
                    title={"Designation"}
                    placeholder={"Select Designation"}
                    value={designationOptions.find(option => option.value === formData.designation) || null}
                    options={designationOptions}
                    onChange={handleDesignationChange}
                    fontSize="12px"
                    textColor="#f1f1f1"
                    fontWeight="400"
                    isShow={true}
                    styles={{
                        control: (provided, state) => ({
                            ...provided,
                            width: "100%",
                            backgroundColor: '#1d1d1d',
                            borderColor: "#f1f1f1",
                            borderRadius: "6px",
                            border: `1px solid #A0A0A0`,
                            boxShadow: 'none',
                            '&:hover': {
                                borderColor: '#f1f1f1'
                            },
                            ':focus': {
                                borderColor: '#f1f1f1',
                                boxShadow: 'none',
                            }
                        }),
                        placeholder: (provided) => ({
                            ...provided,
                            color: '#999999',
                        }),
                        singleValue: (provided) => ({
                            ...provided,
                            color: '#f1f1f1',
                        }),
                        option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected ? '#8BC34A' : '#2d2d2d',
                            color: '#f1f1f1',
                            ':hover': {
                                backgroundColor: state.isSelected ? '#8BC34A' : '#3d3d3d',
                            }
                        }),
                        menu: (provided) => ({
                            ...provided,
                            backgroundColor: '#2d2d2d',
                        }),
                        dropdownIndicator: (provided) => ({
                            ...provided,
                            color: 'var(--Neutral-500, #707070)',
                            '&:hover': {
                                color: 'var(--Neutral-400, #707070)',
                            }
                        }),
                    }}
                />
                {showOtherDesignation && (
                    <CustomInput
                        title={"Please specify your designation"}
                        placeholder={"Your designation"}
                        keyProp={"otherDesignation"}
                        data={formData}
                        onChange={handleChange}
                        isShow={true}
                    />
                )}
                <CustomInput
                    title={"City"}
                    placeholder={"City"}
                    keyProp={"city"}
                    data={formData}
                    onChange={handleChange}
                    isShow={true}
                />
                <ReactSelect
                    title={"Board"}
                    placeholder={"Select Board"}
                    value={boardOptions.find(option => option.value === formData.board) || null}
                    options={boardOptions}
                    onChange={handleBoardChange}
                    fontSize="12px"
                    fontWeight="400"
                    textColor="#f1f1f1"
                    isShow={true}
                    styles={{
                        control: (provided, state) => ({
                            ...provided,
                            width: "100%",
                            backgroundColor: '#1d1d1d',
                            borderColor: "#f1f1f1",
                            borderRadius: "6px",
                            border: `1px solid #A0A0A0`,
                            boxShadow: 'none',
                            '&:hover': {
                                borderColor: '#f1f1f1'
                            },
                            ':focus': {
                                borderColor: '#f1f1f1',
                                boxShadow: 'none',
                            }
                        }),
                        placeholder: (provided) => ({
                            ...provided,
                            color: '#999999',
                        }),
                        singleValue: (provided) => ({
                            ...provided,
                            color: '#f1f1f1',
                        }),
                        option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected ? '#8BC34A' : '#2d2d2d',
                            color: '#f1f1f1',
                            ':hover': {
                                backgroundColor: state.isSelected ? '#8BC34A' : '#3d3d3d',
                            }
                        }),
                        menu: (provided) => ({
                            ...provided,
                            backgroundColor: '#2d2d2d',
                        }),
                        dropdownIndicator: (provided) => ({
                            ...provided,
                            color: 'var(--Neutral-500, #707070)',
                            '&:hover': {
                                color: 'var(--Neutral-400, #707070)',
                            }
                        }),
                    }}
                />
                {showOtherBoard && (
                    <CustomInput
                        title={"Please specify your board"}
                        placeholder={"Your board"}
                        keyProp={"otherBoard"}
                        data={formData}
                        onChange={handleChange}
                        isShow={true}
                    />
                )}
            </div>
            {showAdditionalSections && (
                <><div className={styles.subHeader}>Principal / School Leader’s details:</div><div className={styles.formSection}>

                    <div className={styles.inputContainer1}>
                        <CustomInput
                            title={"Name"}
                            placeholder={"Enter Name"}
                            keyProp={"principalName"}
                            data={formData}
                            onChange={handleChange}
                            isShow={true} />
                    </div>
                    <div className={styles.inputContainer2}>
                        <CustomInput
                            title={"Mobile Number"}
                            placeholder={"+91 12345 67890"}
                            keyProp={"principalNumber"}
                            data={formData}
                            onChange={handleChange}
                            isShow={true} />
                    </div>
                </div></>
            )}
            <div>
                {step == 1 && (
                    <div style={{ margin: "16px 0px" }}>
                        <CustomInput
                            title={"Enter OTP"}
                            placeholder={"Enter OTP"}
                            value={otp}
                            isShow={true}
                            onChange={handleOTPChange}
                        />
                        {resend()}
                    </div>
                )}
                <div
                    className={`${styles.button} ${isDisabled && styles.disabled}`}
                    onClick={() => {
                        if (!isDisabled && !isTrigger) {
                            handleBtnClick();
                        }
                    }}
                >
                    {isTrigger ?
                        <div className={styles.loader} /> :
                        step == 0 ? "Get OTP" : "Submit"
                    }
                </div>
            </div>
        </div>
    );
}

const CustomInput = (props) => {
    const { keyProp, data, onChange, value = "", isShow = true } = props;
    return (
        <div>
            <div className={styles.inputLabel}>
                {props?.title}
                {isShow && <span style={{ color: "#F1F1F1" }}>*</span>}
            </div>
            <input
                className={styles.input}
                placeholder={props?.placeholder}
                value={keyProp ? data[keyProp] : value}
                onChange={(e) => onChange(keyProp, e.target.value)}
            />
        </div>
    );
};

